import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  "aria-label": "Breadcrumb",
  class: "flex"
}
const _hoisted_2 = { class: "inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 1,
  class: "text-sm font-medium text-black dark:text-white"
}
const _hoisted_5 = {
  key: 2,
  "aria-hidden": "true",
  class: "rtl:rotate-180 w-3 h-3 text-gray-400 mx-1",
  fill: "none",
  viewBox: "0 0 6 10",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crumbs, (crumb, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "inline-flex items-center"
        }, [
          (crumb.href)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: crumb.href,
                class: "inline-flex items-center text-sm font-medium text-gray-700 hover:text-primary dark:text-gray-400 dark:hover:text-white"
              }, _toDisplayString(crumb.text), 9, _hoisted_3))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(crumb.text), 1)),
          (index < _ctx.crumbs.length - 1)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[0] || (_cache[0] = [
                _createElementVNode("path", {
                  d: "m1 9 4-4-4-4",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2"
                }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}